const TEXT_BUTTON_SPOILER = "text-button-spoiler";
export {
  TEXT_BUTTON_SPOILER
};
//# sourceMappingURL=data-hooks.js.map
